import React from 'react';

type ExtendArrowsProps = {
  width?: string;
  height?: string;
  color?: string;
};

function ExtendArrows({
  width = '40',
  height = '40',
  color = '#6267AC',
}: ExtendArrowsProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.6667 13.3333L35 5M35 5H26.6667M35 5V13.3333M13.3333 13.3333L5 5M5 5L5 13.3333M5 5L13.3333 5M13.3333 26.6667L5 35M5 35H13.3333M5 35L5 26.6667M26.6667 26.6667L35 35M35 35V26.6667M35 35H26.6667'
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default ExtendArrows;
